import I18n from 'js/lib/i18n.js.erb'
;(function ($) {
  $(document).ready(function () {
    const defaultPath = $(document.body).data('linked-modal-pathway')
    const cookieName = $(document.body).data('donation-modal-cookie-name')
    const pathAliases = I18n.t('payments.donations.path_aliases')
    const $showOnPages = $(['dashboards-show', 'search-listings', 'listings-show', 'blog_posts-show', 'pages-show'])

    $(document).on('modal_closed.donation_modal', function () {
      if (!$.cookie(cookieName)) {
        $.donationPopup.dismiss(1)
      }
    })

    $('.c-footer-popup.donation_modal .actions .later').on('click', function () {
      const $donateLaterContainer = $('.donation_modal--donate_later.init--hidden')

      $donateLaterContainer.slideDown('fast')
      $donateLaterContainer.find('input').focus()
    })

    $('.donation_modal--donate_later .submit').on('click', function () {
      const $emailInput = $('.donation_modal--donate_later input[type="text"]')

      $emailInput.removeClass('error')

      $.ajax({
        type: 'POST',
        url: '/list_subscriptions',
        dataType: 'json',
        data: {
          list_subscription: {
            email: $emailInput.val(),
            agreed_to_donate_later: true,
          },
          list_type: 'core',
        },
        success: function () {
          $.donationPopup.dismiss(365)
          $.donationPopup.close()
        },
        error: function () {
          $emailInput.addClass('error').focus()
        },
      })
    })

    // Todo: this should be moved to the component
    $('.js-c-footer-popup__close').on('click', function () {
      $.donationPopup.dismiss(1)
      $.donationPopup.close()
    })

    $.donationPopup.init(function () {
      const $modal = this.element()
      const params = $.String.deparam(window.location.search.slice(1))
      const displayModal =
        $showOnPages.filter(function (_, klass) {
          return $(document.body).hasClass(klass)
        }).length > 0

      if (window.diableDonationPopup !== true && params.ndm === undefined && displayModal) {
        if (pathAliases[params.path] !== undefined) {
          params.path = pathAliases[params.path]
        }

        if ($('.donation_modal .' + params.path).length) {
          $('.donation_modal .later').show()
        } else {
          params.path = defaultPath
        }

        params.path = $('.donation_modal .' + params.path).length ? params.path : defaultPath

        if (params.donate !== undefined) {
          this.show(params.path, defaultPath)
        } else if ($modal.is('[data-auto-display]')) {
          if ($.cookie(cookieName) !== 'true') {
            $.ajax({
              type: 'POST',
              url: '/payment_paths',
              success: function (response) {
                $.donationPopup.show(response.data.type, defaultPath)
              },
            })
          }
        }
      } else {
        if (params.donate !== undefined) {
          $('[data-shout-token]:first').trigger('click')
        }
      }
    })
  })
})(jQuery)
